import React from 'react';
import classNames from 'classnames';

import { CLASS_TAG_TYPES } from '@classCreation/data/classTagTypes';
import Field from 'components/Field';
import Select from 'components/Select';
import styles from './ClassTag.module.scss';

export default function ClassTag({
  handleClassTagChange,
  classTag,
  disabled = false,
}) {
  return (
    <Field
      label="Class Tag"
      labelClassName={classNames('hint normal', styles.rootColor)}
    >
      <Select
        className={styles.dropdown}
        placeholder={`Class Tag Type`}
        value={classTag}
        isDisabled={disabled}
        options={CLASS_TAG_TYPES}
        onChange={handleClassTagChange}
      />
    </Field>
  );
}
